/*
 * @Author: Bai.Zhiming
 * @Date: 2017-9-25
 * @LastEditTime: 2021-04-22 17:18:27
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\publicFooter\publicFooter.js
 * @Description: 公用底部
 */

'use strict';
angular.module('publicFooterModule', []).directive('publicFooter', ['publicToolService',
    function(publicToolService) {
        return {
            replace: true,
            restrict: 'E',
            // template: [
            //     '<div class="footer">',
            //     '<div class="foot_text"   ng-if="ISCOMPYRIGHT">',
            //     '2019 新疆日报社（新疆报业传媒〈集团〉有限公司） 版权所有 保留所有权 本系统支持1366*768及以上分辨率',
            //     '<div class="trsScrollbar"></div></div></div>',
            // ].join(''),
            template: [
                '<div class="footer">',
                '<div class="foot_text">',
                '{{footText}}',
                '</div></div>',
            ].join(''),
            link: function($scope) {
                // fixScrollbarHeight();
                publicToolService.getModeconfiguration('footerInfo', 'commonInfo').then((config) => {
                    $scope.footText = config.test;
                });

                /**
                 * [getTenantDetail description] 获取租户详情                
                 * @return  {[type]}  [return description]
                 */
                // function getTenantDetail() {
                //     var defer = $q.defer();
                //     var currUserInfo = $sessionStorage.get('curUserInfo');
                //     if (currUserInfo) {
                //         $scope.ISCOMPYRIGHT = currUserInfo.COMPYRIGHT == '0';
                //         defer.resolve(currUserInfo);
                //         return defer.promise;
                //     }
                //     var params = {
                //         serviceid: 'mlf_extuser',
                //         methodname: 'getCurrUserInfo',
                //     };
                //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                //         $scope.ISCOMPYRIGHT = data.COMPYRIGHT == '0';
                //         defer.resolve(data);
                //     });
                //     return defer.promise;
                // }

                /**
                 * [fixScrollbarHeight description]
                 * @return  {[type]}  [return description]
                 */
                // function fixScrollbarHeight() {
                //     var $contentTextWrap = $('.content_text_wrap');
                //     var $trsScrollbar = $('.trsScrollbar');
                //     var scroll_box = $('.content_text_wrap')[0];
                //     $contentTextWrap.scroll(function() {
                //         var height =
                //             scroll_box.scrollHeight - Math.ceil(scroll_box.scrollTop) <= scroll_box.clientHeight + 10
                //                 ? window.innerHeight - $('.foot_text').offset().top
                //                 : 0;
                //         $trsScrollbar.height(height);
                //     });
                // }
            },
        };
    },
]);
